import { CallHistoryMethodAction, push } from "connected-react-router";
import { always, isEmpty } from "ramda";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { setErrorMessage } from "../components/formSettings.slice";
import { getIsNextRoute, getIsPrevRoute } from "../router/utilities";

import { useSubmitForm } from ".";

export type NavigationHandler =
  | (() =>
      | Promise<void>
      | CallHistoryMethodAction<[string, unknown?]>
      | (<T>(val: T) => () => T))
  | (<T>(val: T) => () => T);

export const useNavigationHandler = (
  currentRoute: string,
  destinationRoute = "",
  isDestinationRouteValidated = false,
  isPrevRouteValidated = false
): NavigationHandler => {
  const { handleSubmit: formSubmit, formState } = useFormContext();
  const { touched: isTouched } = formState;
  const dispatch = useDispatch();
  const isPrevRoute = getIsPrevRoute(currentRoute, destinationRoute);
  const isNextRoute = getIsNextRoute(currentRoute, destinationRoute);
  const handleSubmit = formSubmit(
    useSubmitForm(currentRoute, destinationRoute)
  );

  return useCallback(() => {
    if (isEmpty(isTouched) && (isPrevRoute || isPrevRouteValidated)) {
      return dispatch(push(destinationRoute));
    }

    if (
      isNextRoute ||
      isDestinationRouteValidated ||
      (!isEmpty(isTouched) && (isPrevRoute || isPrevRouteValidated))
    ) {
      const errorMessage = isPrevRoute
        ? "Uzupełnij wymagane pola zanim powrócisz"
        : "Uzupełnij wymagane pola zanim przejdziesz dalej";
      dispatch(setErrorMessage(errorMessage));

      return handleSubmit();
    }

    return always;
  }, [
    dispatch,
    handleSubmit,
    isDestinationRouteValidated,
    isNextRoute,
    isPrevRoute,
    isPrevRouteValidated,
    isTouched,
    destinationRoute,
  ]);
};
